export const  overdueCode = ["500002"]